import { useMemo } from "react";
import useNewDataFetcher from "../../../../Hooks/newUseDataFetcher";
import GraphTable from "../../../../Components/GraphTable";
import SubheaderTimePeriod from "../../../../Components/SubheaderTimePeriod";

function ByClient() {
  const dataURL = "/api/v1/candidate/status/by-client"
  const { data, dateRange, filterTypes, filters, isReady } = useNewDataFetcher({
    endPoint: dataURL,
  });

  const candidates = useMemo(() => {
    if (!data) return 0;
    let candidateTotal = data.data.reduce((acc, cur) => {
      acc += cur.uniqueCandidates;
      return acc;
    }, 0);
    let joTotal = data.data.reduce((acc, cur) => {
      acc += cur.jobOrders;
      return acc;
    }, 0);
    let candidatesPerJO = Math.ceil(candidateTotal / joTotal);
    return candidatesPerJO;
  }, [data]);

  return (
    <GraphTable data={data} dateRange={dateRange} filterTypes={filterTypes} filters={filters} isReady={isReady} dataURL={dataURL}>
      <h1 className="page-heading">How many candidates are in each stage for our clients?</h1>
      <h2 className="page-subheading">
        <span className="page-data">{candidates}</span> candidates per opening for jobs created <SubheaderTimePeriod data={dateRange} />
      </h2>
    </GraphTable>
  );
}

export default ByClient;
